import React, { useEffect, useRef, useState } from "react";
import vaisseauImg from "../../assets/vaisseau.png";
import explosionImg from "../../assets/explosion.png";

const couleurEnAnglais = {
    rouge: "red",
    bleu: "blue",
    vert: "green",
    jaune: "yellow",
    noir: "black",
    violet: "purple",
  };
  
  function traduireCouleur(couleur) {
    if (!couleur) return "black";
    return couleurEnAnglais[couleur.toLowerCase()] || "black";
  }

function MiniSpaceInvaders({ onTermine }) {
    const canvasRef = useRef(null);
    const [ennemis, setEnnemis] = useState([]);
    const [projectiles, setProjectiles] = useState([]);
    const [vaisseauX, setVaisseauX] = useState(400);
    const [formesDisponibles, setFormesDisponibles] = useState([]);

    const canvasWidth = 800;
    const canvasHeight = 500;
    const vaisseauWidth = 60;
    const vaisseauHeight = 50;
    const explosion = useRef(new Image());
        useEffect(() => {
            explosion.current.src = explosionImg;
        }, []);
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ADMIN_URL}/formes`)
            .then(res => res.json())
            .then(data => {
                const ennemisInitiaux = data
                    .sort(() => 0.5 - Math.random())
                    .slice(0, 10)
                    .map((forme, i) => ({
                        id: forme.id,
                        x: 100 + (i % 5) * 120,
                        y: 50 + Math.floor(i / 5) * 80,
                        alive: true,
                        explosion: false,
                        explosionStart: null,
                        nom: forme.nom,
                        couleur: traduireCouleur(forme.couleur),
                        largeur: forme.largeur,
                        longueur: forme.longueur,
                        rayon: forme.rayon,
                        base: forme.base,
                        hauteur: forme.hauteur,
                        cotes: forme.cotes
                      }));
                setEnnemis(ennemisInitiaux);
            });
    }, []);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "ArrowLeft") {
                setVaisseauX((prev) => Math.max(prev - 20, 0));
            } else if (e.key === "ArrowRight") {
                setVaisseauX((prev) => Math.min(prev + 20, canvasWidth - vaisseauWidth));
            } else if (e.key === " ") {
                // Tirer
                setProjectiles((prev) => [...prev, { x: vaisseauX + vaisseauWidth / 2, y: canvasHeight - vaisseauHeight - 10 }]);
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [vaisseauX]);

    useEffect(() => {
        const interval = setInterval(() => {
            setProjectiles((prev) =>
                prev.map(p => ({ ...p, y: p.y - 10 })).filter(p => p.y > 0)
            );

            setEnnemis((prevEnnemis) => {
                return prevEnnemis.map(ennemi => {
                    if (!ennemi.alive) return ennemi;
                    for (let projectile of projectiles) {
                        if (
                            projectile.x > ennemi.x && projectile.x < ennemi.x + 40 &&
                            projectile.y > ennemi.y && projectile.y < ennemi.y + 40
                        ) {
                            ennemi.alive = false;
                            ennemi.explosion = true;
                            ennemi.explosionStart = Date.now();
                            break;
                        }
                    }
                    return ennemi;
                });
            });
        }, 100);

        return () => clearInterval(interval);
    }, [projectiles]);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvasWidth, canvasHeight);

        // Dessiner ennemis
        ennemis.forEach(ennemi => {
            if (ennemi.explosion && Date.now() - ennemi.explosionStart < 500) {
                ctx.drawImage(explosion.current, ennemi.x, ennemi.y, 50, 50);
                return; // on ne dessine pas la forme si explosion en cours
            }
          
            if (!ennemi.alive) return;
          
            ctx.fillStyle = ennemi.couleur;
            if (ennemi.nom.toLowerCase().includes("rectangle")) {
                ctx.fillRect(ennemi.x, ennemi.y, ennemi.largeur, ennemi.longueur);
            } else if (ennemi.nom.toLowerCase().includes("rond")) {
                ctx.beginPath();
                ctx.arc(ennemi.x, ennemi.y, ennemi.rayon, 0, Math.PI * 2);
                ctx.fill();
            } else if (ennemi.nom.toLowerCase().includes("triangle")) {
                ctx.beginPath();
                ctx.moveTo(ennemi.x, ennemi.y);
                ctx.lineTo(ennemi.x + ennemi.base, ennemi.y);
                ctx.lineTo(ennemi.x, ennemi.y - ennemi.hauteur);
                ctx.closePath();
                ctx.fill();
            } else if (ennemi.nom.toLowerCase().includes("hexagone")) {
                const cote = ennemi.cotes || 10;
                ctx.beginPath();
                for (let i = 0; i < 6; i++) {
                    const angle = (Math.PI / 3) * i;
                    const x = ennemi.x + Math.cos(angle) * cote;
                    const y = ennemi.y + Math.sin(angle) * cote;
                    if (i === 0) ctx.moveTo(x, y);
                    else ctx.lineTo(x, y);
                }
                ctx.closePath();
                ctx.fill();
            }
          });

        // Dessiner vaisseau
        const img = new Image();
        img.src = vaisseauImg;
        img.onload = () => {
            ctx.drawImage(img, vaisseauX, canvasHeight - vaisseauHeight, vaisseauWidth, vaisseauHeight);
        };

        // Dessiner projectiles
        ctx.fillStyle = "#facc15";
        projectiles.forEach(p => {
            ctx.fillRect(p.x - 2, p.y, 4, 10);
        });
    }, [ennemis, vaisseauX, projectiles]);

    useEffect(() => {
        if (ennemis.length > 0 && ennemis.every(e => !e.alive)) {
            setTimeout(() => {
                onTermine();
            }, 500);
        }
    }, [ennemis, onTermine]);

    return (
        <div className="mini-jeu-wrapper">
            <h2 style={{ color: "#facc15", textAlign: "center" }}>🚀 Mini Space Invaders !</h2>
            <canvas
                ref={canvasRef}
                width={canvasWidth}
                height={canvasHeight}
                style={{ backgroundColor: "#000", border: "2px solid #facc15" }}
            />
        </div>
    );
}

export default MiniSpaceInvaders;